import React, { useState, useEffect, useRef } from 'react'
import './TypeAhead.scss'

const TypeAhead = (props, ref) => {
  const node = useRef()
  const [menuStatus, setMenuStatus] = useState(false)
  const _callback = item => {
    props.callback(item)
    setMenuStatus(false)
  }

  const generateListItems = () => {
    if (props?.data?.length) {
      const listItems = props.data.map((item, i) => {
        return (
          <div key={item[props.item_id] || i}>
            <li role='menuitem'
              className='lsn m0 p0 bgc-white br-1-s-green bdrs-4 df oh tal fxdrc'
              key={item[props.item_id]}
              onClick={() => _callback(item)}
            >
              <div className='mt10 mb10 ml20 mr10'>
                <div className='fz15 mb5'>
                  {item[props.item_value]}
                </div>
                {props.showSAPandState ?
                  <>
                    <div className='fz15 mb5'>
                      {item.company_sap_id === 'N/A' ? null : item.company_sap_id}
                    </div>
                    <div className='fz15 mb5'>
                      {item.company_city + ', '+ item.company_state}
                    </div>
                  </> : null}
                <div className='c-gray2 fz13'>
                  {item[props.item_value_additional]}
                </div>
              </div>
            </li>
            <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal'></div>
          </div>
        )
      })
      return (
        <ul role='menu' className='posa w100% bgc-white mt0 pl0 lsn bd1-s-lightgray bdrs-4 t44 mah225 oys bxshmodal z1 curp'>
          {listItems}
        </ul>
      )
    } else if(props.data){
      return (
        <ul role='menu' className='posa w100% bgc-white mt0 pl0 lsn bd1-s-lightgray bdrs-4 t44 mah225 oys bxshmodal z1'>
          <li className='lsn m0 p0 bgc-white br-1-s-green bdrs-4 df oh tal fxdrc curp'>
            <div className='mt10 mb10 ml20 mr10'>
              <div className='fz15 mb5'>
                No results
              </div>
            </div>
          </li>
        </ul>
      )
    }
    return null
  }

  const handleClickOutside = e => {
    if (node.current && node.current.contains(e.target)) {
      return
    }
    setMenuStatus(false)
  }

  useEffect(() => {
    if (menuStatus) {
      document.addEventListener('mousedown', handleClickOutside)

    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [menuStatus])

  useEffect(()=> {
    if (props.data) {
      setMenuStatus(true)
    }
  }, [props.data, setMenuStatus])

  return (
    <div className={`posr${props.loading ? ' loading' : ''}`} ref={node}>
      <input
        id={props.id}
        name={props.name}
        ref={ref}
        placeholder={props.placeholder}
        className={props.className}
        autoComplete='off'
        value={props.value}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      {menuStatus && generateListItems()}
    </div>
  )
}

export default React.forwardRef(TypeAhead)